<script>
    import { onMount } from "svelte";

    let list = ["Therapy", "Mentorship", "Wellness Camp"];
    export let itemSelected = {};
    onMount((e) => {
        itemSelected = { item: list[0], i: 0 };
    });
</script>

<div class="flex justify-center">
    <div class=" md:w-1/2 pt-20 pb-10 md:px-32">
        <div class="flex justify-between  space-x-5">
            {#each list as item, i}
                <span
                    on:keypress
                    on:click={() => {
                        itemSelected = { item, i };
                    }}
                    class={itemSelected.item == item
                        ? "text-slate-700 hover-underline-animation"
                        : "text-slate-400 hover-underline-animation"}
                >
                    {item}
                </span>
            {/each}
        </div>
    </div>
</div>

<style>
    .hover-underline-animation {
        display: inline-block;
        position: relative;
    }

    .hover-underline-animation::after {
        content: "";
        position: absolute;
        width: 50%;
        transform: scaleX(0);
        height: 2px;
        top: 25px;
        left: 50%;
        background-color: #3e0cd671;
        transform-origin: bottom right;
        transition: transform 0.35s ease-out;
    }

    .hover-underline-animation:hover::after {
        transform: scaleX(1);
        transform-origin: bottom left;
    }
</style>
